__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-04-10-1775820317-stable-dev/";